<template>
  <card>
    <list
      v-if="$store.state.user.sections['report/subscriptions']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="false"
      :setImport="true"
      :exportFields="exportFields"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        "Номер заявки": {
          field: "id",
          callback: (value) => {
            return value;
          },
        },

        "Статус контроля": {
          field: "state_display",
          callback: (value) => {
            return value;
          },
        },
        "Ссылка PDF страховой": {
          field: "file_insurance",
          callback: (value) => {
            return value;
          },
        },
        "ИД отправленное в страховую / название файла": {
          field: "claim_id",
          callback: (value) => {
            return value;
          },
        },
        // "Статус блокировки": {
        //   field: "subscription_status.status",
        //   callback: (value) => {
        //     return value;
        //   },
        // },
        "Дата установки статуса блокировки": {
          field: "subscription_status.time",
          callback: (value) => {
            return value;
          },
        },

        "Дата заявки": {
          field: "start_date",
          callback: (value) => {
            return value;
          },
        },
        "Дата окончания": {
          field: "end_date",
          callback: (value) => {
            return value;
          },
        },
        "Полное имя покупателя": {
          field: "user_fullname",
          callback: (value) => {
            return value;
          },
        },
        Пол: {
          field: "user_gender",
          callback: (value) => {
            return value ? "Мужской" : "Женский";
          },
        },
        "Полное имя оператора": {
          field: "user",
          callback: (value) => {
            return value.name;
          },
        },
        "Офис продаж": {
          field: "shop",
          callback: (value) => {
            return value.name;
          },
        },
        "Номер паспорта": {
          field: "user_passport",
          callback: (value) => {
            return value;
          },
        },
        "Контактный номер": {
          field: "user_phone",
          callback: (value) => {
            return value;
          },
        },
        ПИНФЛ: {
          field: "user_pinfl",
          callback: (value) => {
            return value;
          },
        },
        ПИНФЛ: {
          field: "user_pinfl",
          callback: (value) => {
            return value;
          },
        },
        "Абонентский номер": {
          field: "phone_control",
          callback: (value) => {
            return value;
          },
        },
        "Модель девайса": {
          field: "product_name",
          callback: (value) => {
            return value;
          },
        },
        "Баркод девайса": {
          field: "product_barcode",
          callback: (value) => {
            return value;
          },
        },
        "Баркод девайса": {
          field: "product_barcode",
          callback: (value) => {
            return value;
          },
        },
        "Срок действия договора": {
          field: "loan_period",
          callback: (value) => {
            return value;
          },
        },
        "Итоговая сумма": {
          field: "product_price",
          callback: (value) => {
            return value;
          },
        },
        "Итоговая сумма": {
          field: "product_price",
          callback: (value) => {
            return value;
          },
        },
        Статус: {
          field: "status",
          callback: (value) => {
            return value.name;
          },
        },
        "ИМЕИ 1": {
          field: "imeis",
          callback: (value) => {
            try {
              return value[0].number;
            } catch (error) {}
          },
        },
        "ИМЕИ 1 (СТАТУС)": {
          field: "imeis",
          callback: (value) => {
            try {
              return value[0].status;
            } catch (error) {}
          },
        },
        "ИМЕИ 2": {
          field: "imeis",
          callback: (value) => {
            try {
              return value[1].number;
            } catch (error) {}
          },
        },
        "ИМЕИ 2 (СТАТУС)": {
          field: "imeis",
          callback: (value) => {
            try {
              return value[1].status;
            } catch (error) {}
          },
        },

        "Номер полиса": {
          field: "insurance_polis_number",
          callback: (value) => {
            return value;
          },
        },
        "Награда страховки": {
          field: "insurance_premium",
          callback: (value) => {
            return value;
          },
        },
        "Сумма компенсации": {
          field: "insurance_amount",
          callback: (value) => {
            return value;
          },
        },
        "Основной лимит": {
          field: "limit",
          callback: (value) => {
            return value;
          },
        },
        "Маркетинговый лимит": {
          field: "limit_preview",
          callback: (value) => {
            return value;
          },
        },
      },
      staticFilters: [
        {
          title: "Фильтр по блокировке",
          key: "subscription_status",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "block",
              title: "Блокированы",
            },
            {
              id: "unblock",
              title: "Разблокировано",
            },
            {
              id: "detach",
              title: "Снято с контроля",
            },
            {
              id: "none",
              title: "Нет запросов",
            },
          ],
        },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "status",
          title: "Фильтр по статусам",
          titleKey: "status_filter",
          field_key: "status",
          selectKey: "name",
        },
        {
          key: "shop",
          title: "Фильтр по локациям",
          titleKey: "filter_shop",
          field_key: "shop",
          selectKey: "name",
        },
      ],
      params: {
        per_page: 30,
      },
      val: [],
      modalCreate: "business",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_subscription",
      itemLink: "report/subscriptions",
      setLink: "report/subscriptions",
      columns: [
        { detail: true },
        {
          key: "id",
          title: "ID",
          titleKey: "id",
        },
        {
          key: "claim_id",
          title: "CLAIM ID (INSURANCE)",
          full: true,
          disableLink: true,
        },
        {
          key: "file_insurance",
          title: "INSURANCE FILE",
          full: true,
          link: true,
        },

        {
          key: "phone_control",
          titleKey: "phone_control",
          title: "Абонентский номер",
        },
        {
          key: "imeis",
          titleKey: "imeis",
          title: "Имеи",
          object: "number",
          disableLink: true,
          full: true,
        },

        {
          key: "state_display",
          title: "Статус контроля",
          titleKey: "state_control",
        },
        // {
        //   key: "subscription_status",

        //   title: "Статус блокировки",
        //   object: "status",
        //   disableLink: true,
        // },
        // {
        //   key: "subscription_status",
        //   title: "Дата установки статуса блокировки",
        //   object: "time",
        //   disableLink: true,
        // },

        {
          key: "start_date",
          titleKey: "date_doc",
          title: "Дата договора",
          dateFormat: true,
        },

        {
          key: "user_fullname",
          titleKey: "user_fullname",
          title: "ФИО Покупателя",
          full: true,
        },
        {
          key: "user",
          titleKey: "employee",
          title: "Оператор",
          object: "name",
          disableLink: true,
          full: true,
        },
        {
          key: "shop",
          titleKey: "shop",
          title: "Магазин",
          object: "name",
          disableLink: true,
          full: true,
        },

        {
          key: "user_passport",
          titleKey: "user_passport",
          title: "Номер паспорта",
        },
        {
          key: "user_phone",
          titleKey: "user_phone",
          title: "Контактный номер клиента",
        },
        {
          key: "user_pinfl",
          titleKey: "user_pinfl",
          title: "ПИНФЛ",
        },

        {
          key: "product_name",
          titleKey: "product_name",
          title: "Модель девайса",
          full: true,
        },
        {
          key: "product_barcode",
          titleKey: "product_barcode",
          title: "Баркод девайса",
          full: true,
        },
        {
          key: "loan_period",
          titleKey: "loan_period",
          title: "Срок действия договора",
        },

        {
          key: "product_price",
          titleKey: "total_price",
          title: "Итоговая сумма",
          price: true,
        },
        {
          key: "status",
          titleKey: "status",
          title: "Статус",
          object: "name",
        },

        {
          key: "insurance_polis_number",
          titleKey: "insurance_polis_number",
          title: "Номер полиса",
        },
        {
          key: "insurance_premium",
          titleKey: "insurance_premium",
          title: "Награда страховки",
          price: true,
        },
        {
          key: "insurance_amount",
          titleKey: "insurance_amount",
          title: "Сумма компенсации",
          price: true,
        },

        {
          key: "limit",
          titleKey: "limit",
          title: "Основной лимит",
          price: true,
        },

        {
          key: "limit_preview",
          titleKey: "limit_preview",
          title: "Маркетинговый лимит",
          price: true,
        },
        {
          key: "created_at",
          title: "Дата создания заявки",
        },
      ],
    };
  },
};
</script>
<style>
</style>
